var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500488,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_810_10984)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500488,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_810_10984)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_810_10984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 60.0005C27.3933 60.0005 27.285 59.9805 27.1817 59.9372C26.87 59.8088 26.6667 59.5038 26.6667 59.1672V51.6672H24.1667C21.87 51.6672 20 49.7972 20 47.5005V24.1672C20 21.8705 21.87 20.0005 24.1667 20.0005H55.8333C58.13 20.0005 60 21.8705 60 24.1672V47.5005C60 49.7972 58.13 51.6672 55.8333 51.6672H36.1783L28.0883 59.7572C27.93 59.9155 27.7167 60.0005 27.5 60.0005ZM24.1667 21.6672C22.7883 21.6672 21.6667 22.7888 21.6667 24.1672V47.5005C21.6667 48.8788 22.7883 50.0005 24.1667 50.0005H27.5C27.96 50.0005 28.3333 50.3738 28.3333 50.8338V57.1555L35.2433 50.2455C35.4 50.0888 35.6117 50.0005 35.8333 50.0005H55.8333C57.2117 50.0005 58.3333 48.8788 58.3333 47.5005V24.1672C58.3333 22.7888 57.2117 21.6672 55.8333 21.6672H24.1667Z",
    fill: "#CCCCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 35.0004C38.1615 35.0004 36.6665 33.5054 36.6665 31.6671C36.6665 29.8287 38.1615 28.3337 39.9998 28.3337C41.8382 28.3337 43.3332 29.8287 43.3332 31.6671C43.3332 33.5054 41.8382 35.0004 39.9998 35.0004ZM39.9998 30.0004C39.0815 30.0004 38.3332 30.7487 38.3332 31.6671C38.3332 32.5854 39.0815 33.3337 39.9998 33.3337C40.9182 33.3337 41.6665 32.5854 41.6665 31.6671C41.6665 30.7487 40.9182 30.0004 39.9998 30.0004Z",
    fill: "#CCCCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 51.6671C39.5398 51.6671 39.1665 51.2937 39.1665 50.8337V34.1671C39.1665 33.7071 39.5398 33.3337 39.9998 33.3337C40.4598 33.3337 40.8332 33.7071 40.8332 34.1671V50.8337C40.8332 51.2937 40.4598 51.6671 39.9998 51.6671Z",
    fill: "#CCCCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 53.3337C33.7067 53.3337 33.3333 52.9604 33.3333 52.5004V45.3454L27.7433 39.7554C27.5883 39.6004 27.5 39.3887 27.5 39.1671V34.1671C27.5 33.7071 27.8733 33.3337 28.3333 33.3337C28.7933 33.3337 29.1667 33.7071 29.1667 34.1671V38.8221L34.7567 44.4121C34.9117 44.5671 35 44.7787 35 45.0004V52.5004C35 52.9604 34.6267 53.3337 34.1667 53.3337Z",
    fill: "#CCCCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 35.0004C26.495 35.0004 25 33.5054 25 31.6671C25 29.8287 26.495 28.3337 28.3333 28.3337C30.1717 28.3337 31.6667 29.8287 31.6667 31.6671C31.6667 33.5054 30.1717 35.0004 28.3333 35.0004ZM28.3333 30.0004C27.415 30.0004 26.6667 30.7487 26.6667 31.6671C26.6667 32.5854 27.415 33.3337 28.3333 33.3337C29.2517 33.3337 30 32.5854 30 31.6671C30 30.7487 29.2517 30.0004 28.3333 30.0004Z",
    fill: "#CCCCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 51.6671C45.3733 51.6671 45 51.2937 45 50.8337V45.0004C45 44.7787 45.0883 44.5671 45.2433 44.4104L50.8333 38.8204V34.1671C50.8333 33.7071 51.2067 33.3337 51.6667 33.3337C52.1267 33.3337 52.5 33.7071 52.5 34.1671V39.1671C52.5 39.3887 52.4117 39.6004 52.2567 39.7571L46.6667 45.3454V50.8337C46.6667 51.2937 46.2933 51.6671 45.8333 51.6671Z",
    fill: "#CCCCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6668 35.0004C49.8285 35.0004 48.3335 33.5054 48.3335 31.6671C48.3335 29.8287 49.8285 28.3337 51.6668 28.3337C53.5052 28.3337 55.0002 29.8287 55.0002 31.6671C55.0002 33.5054 53.5052 35.0004 51.6668 35.0004ZM51.6668 30.0004C50.7485 30.0004 50.0002 30.7487 50.0002 31.6671C50.0002 32.5854 50.7485 33.3337 51.6668 33.3337C52.5852 33.3337 53.3335 32.5854 53.3335 31.6671C53.3335 30.7487 52.5852 30.0004 51.6668 30.0004Z",
    fill: "#CCCCE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_810_10984",
    x1: 40,
    y1: 0.000488281,
    x2: 40,
    y2: 80.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_810_10984",
    x1: 40,
    y1: 0.000488281,
    x2: 40,
    y2: 80.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_10984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20.0005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg2);
export default __webpack_public_path__ + "static/media/productivityimg2.179cfe2fa5184768a7f85ea50c189d10.svg";
export { ForwardRef as ReactComponent };